import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const fetchClientServices = createAsyncThunk(
  'clients/services-filter',
  async ({ page = 1, limit = 10, filters = {} }, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams({
        page,
        limit,
        ...filters,
      });

      const res = await axios.get(`${BACKEND_URL}/provider/services-filter?page=${page}&limit=10${queryParams.toString()}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getServiceTypes = createAsyncThunk(
  "provider/get-service-types",
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${BACKEND_URL}/provider/get-service-type`);
      return res.data.service_type;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch service types");
    }
  }
);

export const getServiceLanguages = createAsyncThunk(
  "provider/get-service-lang-tag",
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${BACKEND_URL}/provider/get-service-lang-tag`);
      return {
        languages: res.data.result.language_support,
        tags: res.data.result.addtional_tags
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch service types");
    }
  }
);

const clientServicesSlice = createSlice({
  name: 'clientServices',
  initialState: {
    loading: false,
    error: null,
    clientServices: [],
    serviceTypes: [],
    serviceLanguage: [],
    additionalTags: [],
    pagination: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientServices.fulfilled, (state, action) => {
        state.loading = false;
        state.clientServices = action.payload.services;
        state.pagination = {
  current_page: action.payload.current_page || 1,
  last_page: action.payload.last_page || 1,
  total: action.payload.total || 0,
};
      })
      .addCase(fetchClientServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch providers';
      })
      .addCase(getServiceTypes.fulfilled, (state, action) => {
        state.serviceTypes = action.payload;
      })
      .addCase(getServiceTypes.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(getServiceLanguages.fulfilled, (state, action) => {
        state.serviceLanguage = action.payload.languages;
        state.additionalTags = action.payload.tags;
      })
      .addCase(getServiceLanguages.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default clientServicesSlice.reducer;